import { render, staticRenderFns } from "./MainTwitter.vue?vue&type=template&id=148e3ba2&"
import script from "./MainTwitter.vue?vue&type=script&lang=js&"
export * from "./MainTwitter.vue?vue&type=script&lang=js&"
import style0 from "./MainTwitter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports